import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  icons: {},
  error: null,
};

/**
 * Slice for managing web feature controls state.
 * Includes reducers for fetching controls, setting controls, and handling errors.
 *
 * @type {import("@reduxjs/toolkit").Slice}
 */
export const lottieIconsSlice = createSlice({
  name: "lottieIcons",
  initialState,
  reducers: {
    requestToSetIcons: (state, action) => {
      return {
        ...state,
        icons: action.payload,
      };
    },
  },
});

export const { requestToSetIcons } = lottieIconsSlice.actions;

export default lottieIconsSlice.reducer;
